import "moment/locale/es";
import "moment/locale/pt-br";

import moment from "moment";
import { Locales } from "../i18n/constants";
import { parseLocale } from "../i18n/utils";

const toMomentLocale: Record<Locales, string> = {
  [Locales.ES_PY]: "es",
  [Locales.PT_BR]: Locales.PT_BR,
};

export function setMomentLocale(locale: string) {
  const parsedLocale = parseLocale(locale);
  const momentLocale = toMomentLocale[parsedLocale];
  moment.locale(momentLocale);
}
